import { render, staticRenderFns } from "./Realm.vue?vue&type=template&id=885ef4fe&scoped=true&"
import script from "./Realm.vue?vue&type=script&lang=ts&"
export * from "./Realm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885ef4fe",
  null
  
)

export default component.exports